import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import BussinessOverview from "../components/BussinessOverview.js";
import BussinessReq from "../components/BussinessReq.js";
import UserManagement from "../components/UserManagement.js";
import ProductManagement from "../components/ProductManagement.js";
import Analytics from "../components/Analytics.js";
import CompSetting from "../components/CompSetting.js";
import AnalyticPref from "../components/AnalyticPref.js";
import Payment from "../components/Payment.js";
import Order from "../components/Order.js";
import Wallet from "../components/Wallet.js";
import RequestWithdrawal from "../components/RequestWithdrawal.js";
import BuyCredits from "../components/BuyCredits.js";
import {
  getActiveKeyForPath,
  getRouteForActiveKey,
} from "../utils/businessHubRoutes.js";
import "../styles/UserManagmentPage.css";

const SECTION_COMPONENTS = {
  A: BussinessOverview,
  B: BussinessReq,
  C: UserManagement,
  D: ProductManagement,
  E: Analytics,
  F: CompSetting,
  G: AnalyticPref,
  I: Payment,
  J: RequestWithdrawal,
  K: BuyCredits,
  L: Wallet,
  M: Order,
};

function BusinessHubSectionPage({ activeKey }) {
  const location = useLocation();
  const resolvedActiveKey = activeKey || getActiveKeyForPath(location.pathname);
  const SectionComponent = SECTION_COMPONENTS[resolvedActiveKey];

  if (!SectionComponent) {
    return <Navigate replace to={getRouteForActiveKey("C")} />;
  }

  return (
    <div className="business-hub-screen">
      <div className="business-hub-header-container">
        <BusinessHubHeader />
      </div>
      <div className="business-hub-page-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active={resolvedActiveKey} />
        </div>
        <div className="business-hub-content-container">
          <div className="content-container">
            <SectionComponent />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessHubSectionPage;
